import { render, staticRenderFns } from "./OrgSelect.vue?vue&type=template&id=0a3706c8&scoped=true"
import script from "./OrgSelect.vue?vue&type=script&lang=js"
export * from "./OrgSelect.vue?vue&type=script&lang=js"
import style0 from "./OrgSelect.vue?vue&type=style&index=0&id=0a3706c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3706c8",
  null
  
)

export default component.exports